export default "__VITE_ASSET__3e15bb02__"